import { Route } from 'react-router-dom';
import React, { useEffect } from 'react';
import { Box, Text, Image } from 'rebass';
import greybfyLogo from 'babys-first-year/assets/greybfylogomobile.png';

import StoryDetailError from 'stories/error';
import { useStoryPagesSWR } from '../../story-pages/api';
import { useEntity } from '../../entities/hooks';
import { useMatch } from '../../app/hooks';
import ButtonBar from '../../story-pages/button-bar';
import EditHeader from './header';
import Loading from '../../app/loading';
import MoveStoryPageProvider from './move';
import RejectedFilesModal from '../../story-media/rejected-files';
import StoryPages from '../../story-pages/list';
import TextForm from '../../story-media/text-form';
import EditStoryForm from './form';
import StoryDetailHeaderNav from 'stories/story-detail-header/story-detail-header-nav';
import useLocation from 'app/hooks/location';
import { useStorySWR } from 'stories/api';

const EditStory = ({ refreshBookPages }) => {
  const {
    params: { id },
  } = useMatch();
  const { pathname } = useLocation();
  const { error, revalidate } = useStoryPagesSWR(id, false);
  const { isPresent } = useEntity({ type: 'stories', id });

  const { data, revalidate: revalidateStory } = useStorySWR(id);
  const story = data?.data?.data?.attributes;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [])

  if (error) return <StoryDetailError />;
  if (!isPresent) return <Loading />;
  return (
    <MoveStoryPageProvider>
      <Box mb={['100px', 0]}>
        {pathname?.includes('tell_a_story') && <Box
          mb={3}
          sx={{
            display: ['flex', 'flex', 'none']
          }}
          width="100%" p={2} bg="white" justifyContent={'space-between'} alignItems="center" >
          <Image src={greybfyLogo} width={40} />
          <Text
            m="auto" fontFamily="Poppins" color="#333" fontSize="22px" fontWeight={500} lineheight="20px">
            Edit Story</Text>
        </Box>}
        <StoryDetailHeaderNav refreshBookPages={refreshBookPages} id={id} isFromEdit />
        <EditHeader storyId={id} />

        <Route
          path="/tell_a_story/story/:id/edit/settings"
          render={routeProps => (
            <EditStoryForm
              storyId={id}
              onClose={() => {
                routeProps.history.goBack();
              }}
              story={story}
              revalidateStory={revalidateStory}
              {...routeProps}
            />
          )}
        />

        <Route
          path="/story/:id/edit/settings"
          render={routeProps => (
            <EditStoryForm
              storyId={id}
              onClose={() => {
                routeProps.history.goBack();
              }}
              story={story}
              revalidateStory={revalidateStory}
              {...routeProps}
            />
          )}
        />
        <Route path="/tell_a_story/story/:id/edit/text/:mediumId?">
          <TextForm onClose={revalidate} />
        </Route>
        <Route path="/story/:id/edit/text/:mediumId?">
          <TextForm onClose={revalidate} />
        </Route>
        <ButtonBar storyId={id} position={0} onSuccess={revalidate} />
        <StoryPages storyId={id} editing />
        <RejectedFilesModal />
        <StoryDetailHeaderNav isFromEdit
          refreshBookPages={refreshBookPages}
          id={id} footerSx={{
            display: ['block', 'block', 'none'],
            position: 'fixed',
            bottom: 0,
            width: '100vw',
            zIndex: 3
          }} />
      </Box>
    </MoveStoryPageProvider>
  );
};

export default EditStory;
